var _g, _path, _path2, _path3, _path4, _path5, _rect, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_133_3364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.68629 0 4 2.68629 4 6V36C4 39.3137 6.68629 42 10 42H40C43.3137 42 46 39.3137 46 36V23.987C45.9074 23.9956 45.8136 24 45.7188 24C44.0619 24 42.7188 22.6569 42.7188 21C42.7188 19.3431 44.0619 18 45.7188 18C45.8136 18 45.9074 18.0044 46 18.013V6C46 2.68629 43.3137 0 40 0H10Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6672 34.0555C15.6672 34.6778 16.1709 35.211 16.8227 35.211H34.7515C35.4062 35.211 35.3094 35.3895 35.3094 34.0555V30.6782H15.6672V34.0555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4736 24.5752C26.5106 24.5752 27.3401 23.7456 27.3401 22.7087C27.3401 21.6717 26.5105 20.8422 25.4736 20.8422C24.4366 20.8422 23.6071 21.6717 23.6071 22.7087C23.6071 23.7457 24.4366 24.5752 25.4736 24.5752Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5997 28.0711V29.1376H28.3768V28.0711C28.3768 27.1527 27.9621 26.3232 27.2214 25.7602L27.1325 25.7009L27.0437 25.7305C26.066 26.2341 24.9106 26.2341 23.9329 25.7305L23.844 25.7009L23.7552 25.7602C23.0145 26.3232 22.5997 27.1527 22.5997 28.0711H22.5997Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7315 12.6951L35.7833 10.3843C35.4574 9.55473 35.1909 8.66594 35.0131 7.77711C34.9242 7.36235 34.5688 7.06602 34.1243 7.06602L16.793 7.06623C16.3782 7.06623 15.993 7.36258 15.9041 7.77731C15.7264 8.66615 15.4894 9.55499 15.1339 10.3845L14.2153 12.6951C13.9783 13.258 13.9488 13.8505 14.1265 14.3541C14.4524 15.2725 15.2819 15.865 16.2596 15.865C16.9113 15.865 17.5039 15.5984 17.9484 15.0948C18.2447 14.7689 18.8074 14.7689 19.1038 15.0948C19.5481 15.5984 20.1408 15.865 20.7926 15.865H20.9703C21.5926 15.865 22.185 15.5984 22.5998 15.1539C22.748 15.0057 22.9552 14.9169 23.133 14.9169C23.3995 14.9464 23.5773 15.0353 23.7254 15.1539C24.1402 15.5982 24.7624 15.865 25.3844 15.865H25.6215C26.2437 15.865 26.8362 15.5984 27.2805 15.1539C27.4287 15.0057 27.6064 14.9169 27.8434 14.9169C28.0509 14.9169 28.2582 15.0057 28.4064 15.1539C28.8211 15.5982 29.4434 15.865 30.0359 15.865H30.2136C30.8654 15.865 31.4579 15.5984 31.9024 15.0948C32.1987 14.7689 32.7614 14.7689 33.0578 15.0948C33.4726 15.5688 34.0948 15.865 34.7466 15.865C35.7243 15.865 36.5538 15.2725 36.8797 14.3541C36.9979 13.8505 36.9683 13.258 36.7313 12.6951L36.7315 12.6951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.102 17.376C34.2131 17.4944 33.2652 17.2576 32.5246 16.7243L32.4357 16.6649L32.3468 16.7243C31.6951 17.1686 30.9544 17.4056 30.1842 17.4056H30.0065C29.2658 17.4056 28.5252 17.1686 27.9029 16.7538L27.7843 16.6947L27.6954 16.754C27.0732 17.1688 26.3325 17.4058 25.5623 17.4058H25.3253C24.5551 17.4058 23.844 17.1688 23.1922 16.754L23.1627 16.6947L23.0738 16.754C22.4515 17.1688 21.7109 17.4058 20.9702 17.4058H20.7925C20.0223 17.4058 19.2519 17.1688 18.6299 16.7245L18.541 16.6651L18.4521 16.7245C17.8004 17.1688 17.0597 17.4058 16.2895 17.4058C16.1413 17.4058 16.0229 17.3763 15.8452 17.3763L15.6674 17.3467L15.6672 29.1379H21.0592V28.0714C21.0592 26.7975 21.6221 25.6124 22.5701 24.7533L22.6589 24.6644L22.5996 24.546C22.2442 23.9831 22.0665 23.3611 22.0665 22.7092C22.0665 20.8132 23.6071 19.3023 25.4734 19.3023C27.3694 19.3023 28.8803 20.843 28.8803 22.7092C28.8803 23.361 28.7025 23.9831 28.3471 24.546L28.2878 24.6644L28.3767 24.7533C29.3543 25.6123 29.8875 26.7975 29.8875 28.0714L29.8877 29.1379H35.2797L35.2795 17.5245L35.2499 17.3763L35.102 17.376Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6466,
    y: 30.6083,
    width: 19.6802,
    height: 4.72167,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1624 7H34.811L36.8941 13.408H14L16.1624 7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_133_3364",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_133_3364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_133_3364",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.1bed5d1dfac134e0b41c90013db2e657.svg";
export { ForwardRef as ReactComponent };